export default "__VITE_ASSET__a5qzZIPI__"